import { Injectable } from '@angular/core';
import { AwareSecurityPermissionProvider } from '@appbolaget/aware-security';
import { Store } from '@ngxs/store';
import { UnitState } from 'app/state/unit.state';
import { filter, map } from 'rxjs/operators';
import { AwareAuthService } from '@appbolaget/aware-auth';

@Injectable({ providedIn: 'root' })
export class PermissionProvider implements AwareSecurityPermissionProvider {
    constructor(
        private store: Store,
        private auth: AwareAuthService,
    ) {}

    getPermissions() {
        return this.auth.state$.pipe(map(({ permissions, roles }) => ({ permissions, roles })));
    }

    getUnitId() {
        return this.store.select(UnitState.hierarchy).pipe(
            filter((units) => units.length > 0),
            map((units) => units.map((u) => u.uuid)),
        );
    }
}
